import { render, staticRenderFns } from "./RepeatFrequencySelect.vue?vue&type=template&id=182aac1a&"
import script from "./RepeatFrequencySelect.vue?vue&type=script&lang=ts&"
export * from "./RepeatFrequencySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports